<template>
  <v-navigation-drawer
    class="appDrawer"
    v-model="drawer"
    :mini-variant="!!mini"
    :permanent="!!drawer && !$vuetify.breakpoint.xs"
    touchless
    fixed
    app
    :width="250"
  >
    <v-toolbar color="primary darken-1" flat dark>
      <v-list class="pa-0">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <img src="@/assets/logo-60x60.png" :alt="sistem.app_title" />
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{ sistem.app_title }}</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn icon @click.stop="mini = !mini">
              <v-icon>chevron_left</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-toolbar>
    <vue-perfect-scrollbar
      class="drawer-menu--scroll"
      :settings="scrollSettings"
    >
      <v-list expand dense>
        <v-list-tile v-if="mini">
          <v-list-tile-action>
            <v-btn icon @click.stop="mini = !mini">
              <v-icon>chevron_right</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
        <template v-for="(item, i) in menus">
          <!--group with subitems-->
          <template v-if="item.items">
            <v-list-group
              v-if="showMenuGroup(item.group)"
              :key="i"
              :append-icon="mini ? '' : $vuetify.icons.expand"
              :group="item.group"
              :no-action="!mini"
            >
              <v-list-tile slot="activator" ripple="ripple">
                <v-list-tile-action v-if="item.icon">
                  <v-tooltip
                    right
                    :disabled="!mini || !drawer"
                    :open-delay="50"
                  >
                    <span slot="activator">
                      <v-icon>{{ item.icon }}</v-icon>
                    </span>
                    <h3>{{ item.title }}</h3>
                  </v-tooltip>
                </v-list-tile-action>
                <v-list-tile-content v-if="!mini">
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <template v-for="(subItem, index) in item.items">
                <!--child item-->
                <v-list-tile
                  v-if="showMenu(subItem.name)"
                  :key="`${i}-${index}`"
                  :to="!subItem.href ? { name: subItem.name } : null"
                  :href="subItem.href"
                  :disabled="subItem.disabled"
                  ripple="ripple"
                >
                  <v-list-tile-action v-if="subItem.icon && mini">
                    <v-tooltip right :disabled="!drawer" :open-delay="50">
                      <span slot="activator">
                        <v-icon>{{ subItem.icon }}</v-icon>
                      </span>
                      <h3>{{ subItem.title }}</h3>
                    </v-tooltip>
                  </v-list-tile-action>
                  <v-list-tile-content v-if="!mini">
                    <v-list-tile-title>
                      <span>{{ subItem.title }}</span>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-list-group>
          </template>
          <template v-else-if="item.header">
            <v-subheader v-if="showMenuHeader(item.header)" :key="i">
              {{ item.header }}
            </v-subheader>
          </template>
          <v-divider v-else-if="item.divider" :key="i"> </v-divider>
          <!--group without subitems-->
          <v-list-tile
            v-else-if="showMenu(item.name)"
            :key="i"
            :to="!item.href ? { name: item.name } : null"
            :href="item.href"
            :disabled="item.disabled"
            ripple="ripple"
          >
            <v-list-tile-action v-if="item.icon">
              <v-tooltip right :disabled="!mini || !drawer" :open-delay="50">
                <span slot="activator">
                  <v-icon>{{ item.icon }}</v-icon>
                </span>
                <h3>{{ item.title }}</h3>
              </v-tooltip>
            </v-list-tile-action>
            <v-list-tile-content v-if="!mini">
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </vue-perfect-scrollbar>
  </v-navigation-drawer>
</template>

<script>
import MainMenus from "@/constants/mainMenus";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import routes from "@/router/routes";
import { mapState } from "vuex";

export default {
  name: "app-sidebar",
  components: {
    VuePerfectScrollbar
  },
  data: () => ({
    menus: MainMenus,
    scrollSettings: {
      maxScrollbarLength: 200,
      wheelSpeed: 0.1
    },
    routes: routes
  }),
  computed: {
    ...mapState(["ui"]),
    ...mapState("sistem", ["sistem"]),
    ...mapState("auth", ["profil"]),
    mini: {
      get() {
        return this.ui.sidebar_mini;
      },
      set(value) {
        this.$store.dispatch("SET_SIDEBAR_MINI", value);
      }
    },
    drawer: {
      get() {
        return this.ui.sidebar;
      },
      set(value) {
        this.$store.dispatch("SET_SIDEBAR", value);
      }
    }
  },
  methods: {
    showMenu(name) {
      let route = this.routes.find(r => {
        return r.name == name;
      });
      if (route) {
        return route.meta.role.includes(this.profil.role);
      }
      return false;
    },
    showMenuGroup(group) {
      let menuGroup = this.menus.find(g => {
        return g.group == group;
      });
      let showedMenu = 0;
      for (let i = 0; i < menuGroup.items.length; i++) {
        if (this.showMenu(menuGroup.items[i].name)) showedMenu++;
      }
      return showedMenu > 0;
    },
    showMenuHeader(header) {
      let menuHeader = this.menus.find(h => {
        return h.header == header;
      });
      if (menuHeader.role) {
        return menuHeader.role.includes(this.profil.role);
      }
      return true;
    }
  }
};
</script>

<style scoped>
.appDrawer {
  overflow: hidden;
}
.drawer-menu--scroll {
  height: calc(100vh - 70px);
  overflow: auto;
}
</style>
